export enum EReqHeaders {
  AUTHORIZATION = "Authorization",
  LANGUAGE = "Accept-Language",
  CHANNEL = "X-Channel",
  COMPANY_ID = "Company-id",
}
